/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Link_PricesInputs */

const en_footer_link_prices = /** @type {(inputs: Footer_Link_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prices`)
};

const es_footer_link_prices = /** @type {(inputs: Footer_Link_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precios`)
};

const de_footer_link_prices = /** @type {(inputs: Footer_Link_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preise`)
};

const zh_footer_link_prices = /** @type {(inputs: Footer_Link_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`价格`)
};

const ar_footer_link_prices = /** @type {(inputs: Footer_Link_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأسعار`)
};

const fr_footer_link_prices = /** @type {(inputs: Footer_Link_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarifs`)
};

const vi_footer_link_prices = /** @type {(inputs: Footer_Link_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giá`)
};

const sw_footer_link_prices = /** @type {(inputs: Footer_Link_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei`)
};

const th_footer_link_prices = /** @type {(inputs: Footer_Link_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ราคา`)
};

const bs_footer_link_prices = /** @type {(inputs: Footer_Link_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cijene`)
};

const ja_footer_link_prices = /** @type {(inputs: Footer_Link_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`料金`)
};

const ko_footer_link_prices = /** @type {(inputs: Footer_Link_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`요금`)
};

const pt_footer_link_prices = /** @type {(inputs: Footer_Link_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preços`)
};

const it_footer_link_prices = /** @type {(inputs: Footer_Link_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezzi`)
};

const sv_footer_link_prices = /** @type {(inputs: Footer_Link_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priser`)
};

const nl_footer_link_prices = /** @type {(inputs: Footer_Link_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prijzen`)
};

const da_footer_link_prices = /** @type {(inputs: Footer_Link_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priser`)
};

const nb_footer_link_prices = /** @type {(inputs: Footer_Link_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priser`)
};

const fi_footer_link_prices = /** @type {(inputs: Footer_Link_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinnat`)
};

const pl_footer_link_prices = /** @type {(inputs: Footer_Link_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cennik`)
};

const ru_footer_link_prices = /** @type {(inputs: Footer_Link_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цены`)
};

const tr_footer_link_prices = /** @type {(inputs: Footer_Link_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiyatlar`)
};

const hi_footer_link_prices = /** @type {(inputs: Footer_Link_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कीमतें`)
};

const id_footer_link_prices = /** @type {(inputs: Footer_Link_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga`)
};

const ms_footer_link_prices = /** @type {(inputs: Footer_Link_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga`)
};

const cs_footer_link_prices = /** @type {(inputs: Footer_Link_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ceny`)
};

const el_footer_link_prices = /** @type {(inputs: Footer_Link_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Τιμές`)
};

const he_footer_link_prices = /** @type {(inputs: Footer_Link_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מחירים`)
};

const af_footer_link_prices = /** @type {(inputs: Footer_Link_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pryse`)
};

const hu_footer_link_prices = /** @type {(inputs: Footer_Link_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Árak`)
};

/**
* | output |
* | --- |
* | "Prices" |
*
* @param {Footer_Link_PricesInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const footer_link_prices = /** @type {((inputs?: Footer_Link_PricesInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Link_PricesInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_footer_link_prices(inputs)
	if (locale === "de") return de_footer_link_prices(inputs)
	if (locale === "zh") return zh_footer_link_prices(inputs)
	if (locale === "ar") return ar_footer_link_prices(inputs)
	if (locale === "fr") return fr_footer_link_prices(inputs)
	if (locale === "vi") return vi_footer_link_prices(inputs)
	if (locale === "sw") return sw_footer_link_prices(inputs)
	if (locale === "th") return th_footer_link_prices(inputs)
	if (locale === "bs") return bs_footer_link_prices(inputs)
	if (locale === "ja") return ja_footer_link_prices(inputs)
	if (locale === "ko") return ko_footer_link_prices(inputs)
	if (locale === "pt") return pt_footer_link_prices(inputs)
	if (locale === "it") return it_footer_link_prices(inputs)
	if (locale === "sv") return sv_footer_link_prices(inputs)
	if (locale === "nl") return nl_footer_link_prices(inputs)
	if (locale === "da") return da_footer_link_prices(inputs)
	if (locale === "nb") return nb_footer_link_prices(inputs)
	if (locale === "fi") return fi_footer_link_prices(inputs)
	if (locale === "pl") return pl_footer_link_prices(inputs)
	if (locale === "ru") return ru_footer_link_prices(inputs)
	if (locale === "tr") return tr_footer_link_prices(inputs)
	if (locale === "hi") return hi_footer_link_prices(inputs)
	if (locale === "id") return id_footer_link_prices(inputs)
	if (locale === "ms") return ms_footer_link_prices(inputs)
	if (locale === "cs") return cs_footer_link_prices(inputs)
	if (locale === "el") return el_footer_link_prices(inputs)
	if (locale === "he") return he_footer_link_prices(inputs)
	if (locale === "af") return af_footer_link_prices(inputs)
	if (locale === "hu") return hu_footer_link_prices(inputs)
	return en_footer_link_prices(inputs)
});